"use client";

import { c as _c } from "react/compiler-runtime";
import { useUIStore } from "@/core/state/ui-store";

/**
 * A clean, mobile-aware hook for accessing responsive state.
 * Use this in any component that needs to adapt its UI based on viewport or sidebar state.
 */
export function useResponsive() {
  const $ = _c(10);
  const {
    isMobile,
    isTablet,
    isDesktop,
    breakpoint,
    isSidebarOpen,
    isSidebarCollapsed,
    toggleSidebar,
    setSidebarOpen,
    setSidebarCollapsed
  } = useUIStore();
  let t0;
  if ($[0] !== breakpoint || $[1] !== isDesktop || $[2] !== isMobile || $[3] !== isSidebarCollapsed || $[4] !== isSidebarOpen || $[5] !== isTablet || $[6] !== setSidebarCollapsed || $[7] !== setSidebarOpen || $[8] !== toggleSidebar) {
    t0 = {
      isMobile,
      isTablet,
      isDesktop,
      breakpoint,
      isSidebarOpen,
      isSidebarCollapsed,
      toggleSidebar,
      setSidebarOpen,
      setSidebarCollapsed
    };
    $[0] = breakpoint;
    $[1] = isDesktop;
    $[2] = isMobile;
    $[3] = isSidebarCollapsed;
    $[4] = isSidebarOpen;
    $[5] = isTablet;
    $[6] = setSidebarCollapsed;
    $[7] = setSidebarOpen;
    $[8] = toggleSidebar;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  return t0;
}